import { FC } from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

interface WaitingBackdropProps {
  isWorking: boolean;
  message?: string;
  progress?: number; // 0-100
}

export const WaitingBackdrop: FC<WaitingBackdropProps> = ({ isWorking, message, progress }) => {
  const showProgress = progress !== undefined && progress > 0;

  return (
    <Backdrop open={isWorking} style={{ zIndex: 2000, color: "#fff" }}>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {/* Progress circle or indeterminate spinner */}
        <Box sx={{ position: "relative", display: "inline-flex" }}>
          <CircularProgress
            color="inherit"
            variant={showProgress ? "determinate" : "indeterminate"}
            value={showProgress ? progress : undefined}
            size={80}
            thickness={4}
          />
          {/* Percentage text overlay for determinate */}
          {showProgress && (
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" component="div" color="inherit" sx={{ fontWeight: "bold" }}>
                {`${Math.round(progress)}%`}
              </Typography>
            </Box>
          )}
        </Box>
        <Typography variant="h6" sx={{ mt: 2 }}>
          {message ?? "Bitte warten, Druckvorgang läuft..."}
        </Typography>
      </Box>
    </Backdrop>
  );
};
